import cx from 'classnames'

type Props = {
  title: string
  highlighted: boolean
}

export const Title = ({title, highlighted}: Props) => {
  return (
    <div className="flex gap-3 items-center">
      <div className={cx('font-medium', highlighted ? '' : 'text-gray-0')}>{title}</div>
    </div>
  )
}
